exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img.placeholder {\n  height: 160px;\n  width: 160px;\n  border-radius: 50%;\n}\n\n.shadow-border{\n  border-radius: 25px;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  width: 100%;\n  height: 100%;\n  min-height: 200px;\n  min-width: 200px;\n  max-height: 280px;\n  max-width: 260px;\n  overflow: hidden;\n}\n\n.content {\n  padding: 15px;\n  position: relative;\n  left: 0;\n  right: 0;\n  background-color: transparent;\n}\n\nh2 {\n  font-size: 250%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Jose.Soto/Documents/Websites/SecretSanta/src/app/user-window/user-window.component.css
// module id = ../../../../../src/app/user-window/user-window.component.css
// module chunks = main